import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('agent-certificate')
@Component({
    selector: 'app-agent-certificate',
    templateUrl: './agent-certificate.component.html',
    styleUrls: ['./agent-certificate.component.scss'],
    standalone: false
})
export class AgentCertificateComponent extends FormEntryComponentClass implements OnInit, AfterViewInit {

  constructor() {
    super();
  }

}
